import { makeAutoObservable } from 'mobx';

export interface INavigationStore {
	paymentErrorShow: boolean;
	closeSOCounter: number;
	showLoader: boolean;
	showChangeMailScreen: boolean;
	setPaymentErrorShown: (p: boolean) => void;
	setCloseSOCounterValue: (p: number) => void;
	setLoaderShown: (p: boolean) => void;
	setChangeMailScreenShown: (p: boolean) => void;
}

export class NavigationStore implements INavigationStore {
	paymentErrorShow = false;
	expandViewStripe = true;
	closeSOCounter = 0;
	showLoader = false;
	showChangeMailScreen = false;

	constructor() {
		makeAutoObservable(this);
	}

	setPaymentErrorShown = (shown: boolean): void => {
		this.paymentErrorShow = shown;
	};

	setCloseSOCounterValue = (value: number): void => {
		this.closeSOCounter = value;
	};

	setLoaderShown = (shown: boolean): void => {
		this.showLoader = shown;
	};

	setChangeMailScreenShown = (shown: boolean): void => {
		this.showChangeMailScreen = shown;
	};
}
